// The banners' shared bits (STAGE_6 6.7), apart from the component for fast refresh.

import { tokenStore } from '@/api/tokens';

export const LIVE_CONFIG_KEY = 'live-config';

/** Leave the borrowed session: the vendor's own comes back, on the vendor's page. */
export function stopImpersonating(): void {
  tokenStore.endImpersonation();
  window.location.assign('/vendor');
}
